import type { OptionDB } from "@project/emerge";
import { Sides } from "@project/emerge-types";
import { Covers } from "../enum/Covers";
import { LTProducts } from "../enum/LTProducts";
import type { FlightCaseSettings } from "../interfaces/FlightCaseSettings";
import {
  createCoverOptions,
  createRackInterior,
} from "../structure/RackInterior";
import { FlightCaseDefinition } from "./FlightCaseDefinition";

export class SingleDoorCase extends FlightCaseDefinition {
  public static getSerializedDefaultVersion(
    optionDb: OptionDB,
  ): FlightCaseSettings {
    const result: FlightCaseSettings =
      FlightCaseDefinition.getSerializedDefaultVersion(optionDb);
    result.type = LTProducts.SingleDoor;
    result.exteriorOptions.strength = 6.5;
    result.variableOptions = [];
    result.interiorOptions = createRackInterior(optionDb);
    result.cuts = [
      {
        offset: 50,
        reference: Sides.FRONT,
        groupName: Covers.COVER,
      },
    ];
    result.coverPaddings = createCoverOptions(optionDb, result.cuts);
    return result;
  }
}
